<template>
  <div>

    <header-sales></header-sales>

    <div  id="headerImageContainer" >
      <img id="headerImage" src="/dist/logo-header.png" style="height: 180px;">
    </div>

    <div id="mainContainer">

      <div id="promoDescLabelContainer">

        <div style="margin-bottom: 20px;  width: 485px ;background-color: #ffffff"  >
          <span class="tituloSeccion">Promociones</span>
          <span class="verTodos" @click="btnVerPromociones" >Ver Todas</span>
        </div>

        <div style="margin-bottom: 20px ;background-color: #ffffff"  >
          <span class="tituloSeccion">Descuentos</span>
          <span class="verTodos" @click="btnVerDescuentos" >Ver Todos</span>
        </div>

      </div>


      <div id="promoDescContainer">
        <div id="promoContainer">
          <item-promocion v-for="item in itemsPromo " :item='item'></item-promocion>
        </div>
        <div id="descContainer" @click="btnVerDescuentos">
          <item-descuento v-for="item in itemsDescuento " :item='item'></item-descuento>
        </div>
      </div>


      <div style="margin-bottom: 20px; margin-top: 20px">
        <span   id="labelEstado" class="tituloSeccion">Estado de Pedidos</span>
        <span  class="verTodos" @click="btnVerEstadoPedidos" >Ver Todos</span>
      </div>

      <div  id="pedidoContainer">

        <div class="oblea-NuevoPedido" @click="btnNuevoPedido">
          <img id="icon-add" style="width: 30px; height: 30px" src="/dist/icon-add.png" >
          <p id="label-realizarPedido">Nuevo Pedido</p>
        </div>

        <item-pedido-home v-for="item in itemsPedido" :item='item'></item-pedido-home>
      </div>

    </div>

  </div>
</template>


<script>
  import axios from 'axios'
  import HeaderSales from '@components/views/header.vue';
  import ItemPedidoHome from '@components/views/home/itemPedidoHome.vue';
  import ItemPromocion from '@components/views/home/itemPromocionHome.vue';
  import ItemDescuento from '@components/views/home/itemDescuentoHome.vue';

  export default {
    name: 'Lista',

    components:{
     'header-sales': HeaderSales,
     'item-pedido-home': ItemPedidoHome,
     'item-promocion': ItemPromocion,
     'item-descuento': ItemDescuento
    },

    computed: {
      promociones() {
        return this.$store.state.pedido.promociones;
      },

      itemsPromo () {
        return this.$store.getters['pedido/getPromoHome']
      },

      itemsDescuento () {
        return this.$store.getters['pedido/getDescuentosHome']
      },

      itemsPedido () {
        return  this.$store.state.pedido.pedidosHome;
      }

    },


    methods: {
      getPromociones: function () {
        this.$store.commit('loader/start')
        axios.get(`/WebSalesPromociones?ListaPrecioId=${this.$store.state.user.listaDePrecio}`,{
            headers:{
                      Token:this.$store.state.user.token,
                      ClientSecret: process.env.CLIENT_SECRET,
                      EmpresaId: process.env.EMPRESA_ID
                    }
            }
          ).then((response) => {
              if (response.data.Code == 0)
              {
                this.$store.commit('pedido/savePromociones',response.data.Promociones)
              }
              else if (response.data.Code == 99)
              {
                this.$store.commit('loader/stop')
                alert(response.data.Message)
                this.$router.push({name: 'login'});
              }
              else
              {
                this.$store.commit('loader/stop')
                alert(response.data.Message);
                console.log(">>code>>"+response.data.Code);
              }
              this.getDescuentos()
          },(error) => {
            this.$store.commit('loader/stop')
            console.log(error)
            alert(error);
            })
      },


      getDescuentos: function () {
        axios.get(`/WebSalesDescuentos?ListaPrecioId=${this.$store.state.user.listaDePrecio}`,{
            headers:{
                      Token:this.$store.state.user.token,
                      ClientSecret: process.env.CLIENT_SECRET,
                      EmpresaId: process.env.EMPRESA_ID
                    }
          }
          ).then((response) => {
              if (response.data.Code == 0)
              {
                this.$store.commit('pedido/saveDescuentos',response.data.Descuentos)
              }
              else if (response.data.Code == 99)
              {
                this.$store.commit('loader/stop')
                alert(response.data.Message)
                this.$router.push({name: 'Login'});
              }
              else
              {
                this.$store.commit('loader/stop')
                alert(response.data.Message);
                console.log(">>code>>"+response.data.Code);
              }
              this.getProductos()
          },(error) => {
            this.$store.commit('loader/stop')
            console.log(error)
            alert(error);
            })
      },



      getProductos: function (idCat,idSubcat) {
        var url = `/WebSalesProductos?ListaPrecioId=${this.$store.state.user.listaDePrecio}`;
        axios.get(url,{
         headers:{
                    Token:this.$store.state.user.token,
                    ClientSecret: process.env.CLIENT_SECRET,
                    EmpresaId: process.env.EMPRESA_ID
                  }
         }
        ).then((response) => {
         this.$store.commit('loader/stop')
         if (response.data.Code == 0)
         {
           this.$store.commit('pedido/saveProductos',response.data.Productos);
         }
         else if (response.data.Code == 99)
         {
           alert(response.data.Message)
           this.$router.push({name: 'login'});
         }
         else
         {
           console.log(">>>>"+response.data.Message);
           alert(response.data.Message);
         }
         this.getEstadoPedidos()
      },(error) => {
        console.log(error)
        alert(error);
        })
      },



      getEstadoPedidos: function () {
        this.pedidoRequest = {
        'FechaDesde': "10/01/2010",
        'FechaHasta': this.getFechaHasta(),
        'ClientesId': [],
        'Estado': 98,
        'Pagina': 1,
        'PedidosXPagina': 2
        }
        axios.post('/WebSalesPedidosListado', this.pedidoRequest ,{
          headers:{
                    Token:this.$store.state.user.token,
                    ClientSecret: process.env.CLIENT_SECRET,
                    EmpresaId: process.env.EMPRESA_ID
                  }
        }).then((response) => {
          this.$store.commit('loader/stop')
          if (response.data.Code == 0)
          {
            this.$store.commit('pedido/savePedidosHome',response.data.Pedidos);
          }
          else if (response.data.Code == 99)
          {
            alert(response.data.Message)
            this.$router.push({name: 'login'});
          }
          else
          {
            console.log(">>>>"+response.data.Message);
            alert(response.data.Message);
          }
        }).catch((error) => {
          alert("error")
          console.log(error);
        });
      },


      btnNuevoPedido: function () {
        this.$store.commit('pedido/setBorradorId',0);
        this.$router.push({ name: 'realizarPedido' });
      },


      btnVerPromociones: function () {
        this.$router.push({ name: 'promociones' });
      },


      btnVerDescuentos: function () {
         this.$router.push({ name: 'descuentos' });
      },


      btnVerEstadoPedidos: function () {
        this.$router.push({ name: 'estadoPedido' });
      },


      getFechaHasta(){
        //'Fecha': "dd/mm/yyyy",  --> 1 dia mas que fecha actual
        var date   =  new Date();
        date.setMilliseconds(date.getMilliseconds()+86400000)
        var dia    =  ''
        var mes    =  ''
        if (date.getDate()<10)
        {
          dia = '0'+ date.getDate().toString()
        }
        else
        {
          dia = date.getDate().toString()
        }

        if ((date.getMonth() + 1)<10)
        {
          mes = '0'+ (date.getMonth()+1).toString()
        }
        else
        {
          mes = (date.getMonth()+1).toString()
        }
        return  dia+'/'+mes+'/'+date.getFullYear();
     },


  },

  mounted: function () {
    this.$store.commit('loader/stop')
    if (this.promociones.length == 0)
    {
      this.getPromociones();
    }
  }


 }


</script>

<style scoped>


 #promoDescLabelContainer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
  }


 #promoDescContainer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
  }


 #headerImageContainer {
    width: 100%;
    height: 30vh;
    background: linear-gradient(#005A9F , #1899D6);
    display: flex;
    justify-content: center;
    align-items: center;
  }


 #headerImage {
    height: 140px;
  }


 #mainContainer {
 position: absolute;
 top: 70%;
 left: 50%;
 transform: translate(-50%,-50%);
 width: 700px;
 height: 59vh;
 box-sizing: border-box;
 background-color: #ffffff;
 display: flex;
 flex-direction: column;
 align-items: flex-start;
}


.verTodos{
  font-size: 11px;
  color: #4969B2;
  font-weight: bold;
  margin-left: 15px;
}

.verTodos:hover { cursor: pointer; }


.tituloSeccion{
  font-size: 20px;
  color: black;
  font-weight: 500;
  margin-bottom: 5px;
}


#promoContainer {
 width: 460px;
 height: 150px;
 margin-right: 25px;
 background: #ffffff;
 display: flex;
 flex-direction:row ;
}


#descContainer {
 width: 200px;
 height: 150px;
 background: #ffffff;
 display: flex;
 flex-direction:column ;
}


#labelEstado {
  margin-top: 30px;
}


#pedidoContainer {
 background: #ffffff;
 display: flex;
 flex-direction:row ;
}


.oblea-NuevoPedido{
    width: 190px;
    height: 120px;
    border-width: 1px;
    border: 1px dashed #dddddd;
    background: #ffffff;
    margin-right: 20px;
    padding: 10px 15px 10px 15px;
    display: flex;
    flex-direction:column;
    align-items: center;
    justify-content: center;
  }


.oblea-NuevoPedido:hover{
    cursor: pointer;
    background: #f9f9f9;
  }


#label-realizarPedido{
    margin-top: 5px;
    font-size: 10px;
}





</style>



// WEBPACK FOOTER //
// src/components/views/home/home.vue